import Vue from 'vue'
import VueRouter from 'vue-router'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
const Index = () => import('../components/index.vue') // 路由懒加载(解决页面加载过慢)
const Experiment = () => import('../components/experiment.vue')
const Login = () => import('../components/login.vue')

Vue.use(VueRouter)
Vue.prototype.$video = Video

// 修改路由replace方法,阻止重复点击报错
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

const routes = [{
    path: '/',
    redirect: '/index',
    meta: {
      title: '首页'
    },
    component: Index
  },
  {
    path: '/index',
    name: 'index',
    meta: {
      title: '首页'
    },
    component: Index
  },
  {
    path: '/experiment',
    component: Experiment,
    meta: {
      title: '虚拟实验'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登陆/注册'
    }
  },
  {
    path: '/login',
    name: 'register',
    component: Login,
    meta: {
      title: '登陆/注册'
    }
  },
  // 对于所有的（*代表所有）错误页面，都重定向到 "/index" 中 放在最后
  {
    path: '*',
    redirect: '/index'
  }
]

const router = new VueRouter({
  routes
})

export default router
